import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import SelectUnique from '@/components/_custom/Selector/selectUnique/selectUnique'
import { SelectOptionsDeprecated } from '@/types/Select'
import { useMutation } from '@apollo/client'
import styles from './linkApiClientDaycareDialog.module.scss'
import { useAuth } from '@/modules/context/AuthContext'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { LINK_API_CLIENT_TO_DAYCARE } from '@/modules/API/apiClient/linkApiClient.ts'
import { ApiClientDaycare } from '@/types/ApiClient.ts'

interface LinkDaycareDialogProps {
    open: boolean
    handleClose: () => void
    daycares: ApiClientDaycare[]
    id: number
    refetch: () => void
}

const LinkApiClientDaycareDialog: FunctionComponent<LinkDaycareDialogProps> = ({
    open,
    handleClose,
    daycares,
    id,
    refetch
}: LinkDaycareDialogProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [selectedDaycare, setSelectedDaycare] = useState<string>('')

    const [linkDaycare] = useMutation(LINK_API_CLIENT_TO_DAYCARE, {
        variables: {
            id: id,
            daycareId: Number(selectedDaycare)
        },
        onCompleted: () => {
            showNotificationSuccess(t('structureLinked'))

            refetch()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorLinkingStructure'))
        }
    })

    const daycareOptions: SelectOptionsDeprecated = [
        {
            options:
                user?.daycares
                    .filter((daycare) => daycare.active)
                    .filter((daycare) => !daycares.some((d) => d.id === daycare.id))
                    .map((daycare) => {
                        return {
                            name: daycare.city + ' - ' + daycare.name + ' - #' + daycare.id,
                            value: daycare.id.toString()
                        }
                    }) || []
        }
    ]

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('addStructure')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.SelectContainer}>
                    <SelectUnique
                        selectOptions={daycareOptions}
                        selectValue={selectedDaycare}
                        setSelectValue={setSelectedDaycare}
                        label={t('structure')}
                        formClassName={styles.SelectInput}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type={'add'}
                        onClick={linkDaycare}
                        className={styles.Button}
                        disabled={!selectedDaycare}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default LinkApiClientDaycareDialog
